
import { UserRole } from '@/lib/supabase';

export interface UseRoleCheckReturn {
  hasRole: (roles: UserRole | UserRole[]) => boolean;
}

export const useRoleCheck = (profile: any): UseRoleCheckReturn => {
  const hasRole = (roles: UserRole | UserRole[]) => {
    if (!profile) return false;
    
    if (Array.isArray(roles)) {
      return roles.includes(profile.role);
    }
    
    return profile.role === roles;
  };

  return {
    hasRole
  };
};
